export default "__VITE_ASSET__CByaH_nM__"